// export default function isCompanyClosed (company_state) {
//   if (company_state !== '核准設立') {
//     if (company_state === '歇業'
//     || company_state === '廢止'
//     || company_state === '廢止已清算完結'
//     || company_state === '廢止許可'
//     || company_state === '廢止許可已清算完結'
//     || company_state === '廢止認許'
//     || company_state === '廢止認許已清算完結'
//     || company_state === '廢止登記'
//     || company_state === '撤回認許'
//     || company_state === '撤回認許已清算完結'
//     || company_state === '撤回登記'
//     || company_state === '撤回登記已清算完結'
//     || company_state === '撤銷'
//     || company_state === '撤銷登記'
//     || company_state === '撤銷已清算完結'
//     || company_state === '撤銷無須清算'
//     || company_state === '撤銷許可'
//     || company_state === '撤銷認許'
//     || company_state === '撤銷認許已清算完結'
//     || company_state === '撤銷公司設立'
//     || company_state === '解散'
//     || company_state === '解散已清算完結'
//     || company_state === '合併解散'
//     || company_state === '核准設立，但已命令解散') {
//       return true
//     }
//   }
//   return false
// }

export const isCompanyClosed = (company_operate) => {
  if (company_operate !== '營業中') {
    return true
  }
  return false
}
